import React, { useState, useEffect } from 'react';
import '../../App.css';
import FolderManagerModal from '../modals/FolderManagerModal';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'bootstrap';

const Breadcrumbs = ({
  handlePrint,
  handleDownloadPDF,
  isPdfGenerating,
  handleOpenCustomerModal,
  handleOpenEmailReportModal,
  onCreateNewReport,
  onDeleteCurrentReport,
  reportName,
  customerName,
  isReportSelected,
  isCustomerSelected,
  projectName,
  isProjectSelected,
  financeName,
  isFinanceSelected,
  priceQuoteName,
  isPriceQuoteSelected,
  invoicesName,
  isInvoicesSelected,
  currentSection,
  folders,
  onSaveFolder,
  onCreateFolder,
  onDeleteFolder,
  handleOpenPrefillRowsModal,
  handleDownloadPriceQuotePDF,
  onToggleLock,
  isReportLocked,
  onCreateInvoiceFromReport,
  reportForInvoice
}) => {
  const [showAddFolderModal, setShowAddFolderModal] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(el => new Tooltip(el));

    return () => {
      tooltipList.forEach(tooltip => tooltip.dispose());
    };
  }, []);

  const handleOpenAddFolderModal = () => {
    setShowAddFolderModal(true);
  };

  const handleCloseAddFolderModal = () => {
    setShowAddFolderModal(false);
  };

  const activeDetail = (() => {
    if (isReportSelected && reportName !== currentSection) return reportName;
    if (isCustomerSelected) return customerName;
    if (isProjectSelected) return projectName;
    if (isPriceQuoteSelected) return priceQuoteName;
    if (isFinanceSelected) return financeName;
    if (isInvoicesSelected) return invoicesName;
    return '';
  })();

  return (
    <div className="page-header-breadcrumb">
      <div className="page-header-main">
        <div className="page-header-copy">
          <div className="page-header-kicker">Workspace</div>
          <h1 className="page-header-title">{currentSection}</h1>
          {activeDetail && (
            <div className="page-header-subtitle">{activeDetail}</div>
          )}
        </div>
        <div className="d-flex align-items-center flex-wrap my-auto right-content breadcrumb-right page-header-actions">
          {isReportSelected && (
            <>
              <button type="button" className="btn btn-light btn-icon mx-1 mt-2 mt-xl-0" onClick={handleOpenPrefillRowsModal} data-bs-toggle="tooltip" data-bs-placement="bottom" title={t('prefill_report')}>
                <i className="bi bi-magic"></i>
              </button>
              <button type="button" className="btn btn-light btn-icon mx-1 mt-2 mt-xl-0" onClick={onToggleLock} data-bs-toggle="tooltip" data-bs-placement="bottom" title={isReportLocked ? t('unlock_report') : t('lock_report')} data-bs-original-title={isReportLocked ? t('unlock_report') : t('lock_report')}>
                <i className={`bi ${isReportLocked ? 'bi-unlock-fill text-success' : 'bi-lock-fill text-danger'}`}></i>
              </button>
              <button type="button" className="btn btn-light btn-icon btn-hover-danger mx-1 mt-2 mt-xl-0" onClick={onDeleteCurrentReport} data-bs-toggle="tooltip" data-bs-placement="bottom" title={t('delete_report')}>
                <i className="bi bi-trash"></i>
              </button>
              <button type="button" className="btn btn-light btn-icon mx-1 mt-2 mt-xl-0" onClick={handleOpenEmailReportModal} data-bs-toggle="tooltip" data-bs-placement="bottom" title={t('send_in_email')}>
                <i className="bi bi-envelope-at"></i>
              </button>
              <button type="button" className="btn btn-light btn-icon mx-1 mt-2 mt-xl-0" onClick={handleDownloadPDF} disabled={isPdfGenerating} data-bs-toggle="tooltip" data-bs-placement="bottom" title={isPdfGenerating ? t('pdf_export_in_progress') : t('download_pdf')}>
                <i className={`bi ${isPdfGenerating ? 'bi-arrow-repeat pdf-export-spinner' : 'bi-download'}`}></i>
              </button>
              <button type="button" className="btn btn-light btn-icon mx-1 mt-2 mt-xl-0" onClick={handlePrint} data-bs-toggle="tooltip" data-bs-placement="bottom" title={t('print_report')}>
                <i className="bi bi-printer"></i>
              </button>
              <button
                type="button"
                className="btn btn-light btn-icon mx-1 mt-2 mt-xl-0"
                onClick={() => onCreateInvoiceFromReport(reportForInvoice)}
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                title={t("create_invoice")}
              >
                <i className="bi bi-receipt-cutoff"></i>
              </button>
            </>
          )}
        </div>
      </div>
      <div className="page-header-accent" />
      <FolderManagerModal
        show={showAddFolderModal}
        handleClose={handleCloseAddFolderModal}
        folders={folders}
        onCreateFolder={onCreateFolder}
        onRenameFolder={onSaveFolder}
        onDeleteFolder={onDeleteFolder}
      />
    </div>
  );
};

export default Breadcrumbs;
